import {
  LayoutDashboard, Crown, PiggyBank, ClipboardList, Shield,
  Calendar, Ticket, Users, FileText, MessageSquare,
  Heart, Handshake, Mail, Video, HardDrive, CalendarSync,
  ShoppingBag, Lightbulb, Gamepad2, Gift, Target, DollarSign,
  Package, UtensilsCrossed, ListTodo, Star, Sparkles,
  Zap, Building2, QrCode, ClipboardCheck, Settings,
  Bell, Lock, Key, Image, Link, Globe, Search, Filter,
  Plus, Minus, Edit, Trash2, Check, X, ChevronRight,
  ChevronDown, ChevronUp, Menu, Home, User, LogOut,
  Upload, Download, Share, Copy, Eye, EyeOff
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

export const iconMap: Record<string, LucideIcon> = {
  LayoutDashboard,
  Crown,
  PiggyBank,
  ClipboardList,
  Shield,
  Calendar,
  Ticket,
  Users,
  FileText,
  MessageSquare,
  Heart,
  Handshake,
  Mail,
  Video,
  HardDrive,
  CalendarSync,
  ShoppingBag,
  Lightbulb,
  Gamepad2,
  Gift,
  Target,
  DollarSign,
  Package,
  UtensilsCrossed,
  ListTodo,
  Star,
  Sparkles,
  Zap,
  Building2,
  QrCode,
  ClipboardCheck,
  Settings,
  Bell,
  Lock,
  Key,
  Image,
  Link,
  Globe,
  Search,
  Filter,
  Plus,
  Minus,
  Edit,
  Trash2,
  Check,
  X,
  ChevronRight,
  ChevronDown,
  ChevronUp,
  Menu,
  Home,
  User,
  LogOut,
  Upload,
  Download,
  Share,
  Copy,
  Eye,
  EyeOff,
};

export const availableIcons = Object.keys(iconMap);

export const getIcon = (iconName: string): LucideIcon => {
  return iconMap[iconName] || Star;
};
